export default function QuickBooksPane({ children: renderBody }) {
  // use existing credential or create a new one;
  const body = null;

  return renderBody(body, false);
}
